import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const BASE = "/api/userClientAccess";

export const userClientAccessService = {
  // Get all clients a user can access
  getByUser: async (userId) => {
    return api.getCall(`${BASE}/user/${userId}`);
  },

  // Get all users who can access a client
  getByClient: async (clientId) => {
    return api.getCall(`${BASE}/client/${clientId}`);
  },

  // Get clients the user does NOT yet have access to
  availableClients: async (userId) => {
    return api.getCall(`${BASE}/available-clients/${userId}`);
  },

  // Get users who do NOT yet have access to a client
  availableUsers: async (clientId) => {
    return api.getCall(`${BASE}/available-users/${clientId}`);
  },

  // Grant a user access to a client
  grant: async (userId, clientId) => {
    return api.postCall(`${BASE}/grant`, { userId, clientId });
  },

  // Grant a user access to multiple clients
  grantBulk: async (userId, clientIds) => {
    return api.postCall(`${BASE}/grant-bulk`, { userId, clientIds });
  },

  // Revoke a user's access to a client
  revoke: async (userId, clientId) => {
    return api.postCall(`${BASE}/revoke`, { userId, clientId });
  },

  // Revoke a user's access to multiple clients
  revokeBulk: async (userId, clientIds) => {
    return api.postCall(`${BASE}/revoke-bulk`, { userId, clientIds });
  },

  // Deny an admin access to a client (block)
  deny: async (userId, clientId) => {
    return api.postCall(`${BASE}/deny`, { userId, clientId });
  },

  // Deny an admin access to multiple clients (block)
  denyBulk: async (userId, clientIds) => {
    return api.postCall(`${BASE}/deny-bulk`, { userId, clientIds });
  },

  // Remove a denial for an admin (unblock)
  undeny: async (userId, clientId) => {
    return api.postCall(`${BASE}/undeny`, { userId, clientId });
  },
};
